import React, { useEffect, useState } from "react";
import PocketBase from "pocketbase";
import Box from "@mui/material/Box";
import {
  Card,
  CardContent,
  CardHeader,
  TextField,
  Button,
  Typography,
  Pagination,
} from "@mui/material";
import Header from "./Header";

const pb = new PocketBase("https://app.childrensboard.org");
pb.autoCancellation(false);

function Pledge() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pledges, setPledges] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPledges, setTotalPledges] = useState(0);
  const pledgesPerPage = 5;

  useEffect(() => {
    const authenticateAdmin = async () => {
      try {
        await pb.admins.authWithPassword("cbit@cbhcfl.gov", "cBW@W1m2c$DE");
        fetchPledges();
      } catch (error) {
        console.error("Admin authentication failed:", error);
      }
    };

    authenticateAdmin();
  }, [currentPage]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = { name, email };

    try {
      await pb.collection("pledges").create(data);
      fetchPledges();
      setName("");
      setEmail("");
    } catch (error) {
      console.error("Error creating pledge:", error);
    }
  };

  const fetchPledges = async () => {
    try {
      const pledgesList = await pb
        .collection("pledges")
        .getList(currentPage, pledgesPerPage, {
          sort: "-created",
        });
      setPledges(pledgesList.items);
      setTotalPledges(pledgesList.totalItems); // Assuming totalItems gives you the total count
    } catch (error) {
      console.error("Error fetching pledges:", error);
    }
  };
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="App">
      <Header title="Sign the Pledge" />
      <Card style={{ maxWidth: 600, margin: "auto", marginTop: "20px" }}>
        <CardContent>
          <Box sx={{ width: "100%", maxWidth: 500 }}>
            <Typography variant="h4" gutterBottom>
              Take the Pledge
              <br />
              To help every baby sleep safer.
            </Typography>
            <Typography variant="body1" gutterBottom>
              Over 200 local infants have died due to unsafe sleep in the Tampa
              Bay Area.
              <br />
              We strongly encourage parents and caregivers to take a pledge to
              practice safe sleep for infants.
              <br />
              <br />
              I Pledge to:
              <br />
              <ul>
                <li>
                  Always place my baby on their back to sleep, for every nap and
                  bedtime.
                </li>
                <li>
                  Keep the sleep area free of soft objects, toys, crib bumpers,
                  and loose bedding.
                </li>
                <li>
                  Use a firm and flat sleep surface, such as a crib or bassinet,
                  with a fitted sheet.
                </li>
                <li>
                  Share a room with my baby but not the same bed, keeping the
                  sleep space close but separate.
                </li>
              </ul>
            </Typography>
          </Box>
          <form onSubmit={handleSubmit}>
            <TextField
              label="Full Name"
              variant="outlined"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              fullWidth
              margin="normal"
            />
            <TextField
              label="Email"
              variant="outlined"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              fullWidth
              margin="normal"
            />
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Sign
            </Button>
          </form>
          <Typography variant="h6" style={{ marginTop: "20px" }}>
            Pledges
          </Typography>
          <Typography>Total Pledges: {totalPledges}</Typography>
          <ul>
            {pledges.map((pledge) => {
              const names = pledge.name.split(" ");
              const firstName = names[0]; // First name is the first element
              const lastName = names[names.length - 1].charAt(0); // Last name's first letter

              const formattedDate = new Date(
                pledge.created
              ).toLocaleDateString();

              return (
                <li key={pledge.id}>
                  {firstName} {lastName}. - {formattedDate}
                </li>
              );
            })}
          </ul>
          <Pagination
            count={Math.ceil(totalPledges / pledgesPerPage)}
            page={currentPage}
            onChange={(event, value) => paginate(value)}
            color="primary"
            style={{ marginTop: "20px" }}
          />
        </CardContent>
      </Card>
    </div>
  );
}

export default Pledge;
